import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

const Disabled = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div
      className={twMerge(
        'pointer-events-none filter grayscale opacity-50',
        className,
      )}
      aria-disabled
    >
      {children}
    </div>
  );
};

export default Disabled;
